<template>
    <base-draggable-modal
        name="edit_meeting"
        max-height="80vh"
        width="50vw"
        :fullscreen="$vuetify.display.xsOnly"
        ref="edit_meeting">
      <v-card rounded="xl">
        <base-modal>
          <template #header>
            <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
              <v-toolbar-title class="text-primary">{{ $store.getters.translate('edit') }} {{ $store.getters.translate('meeting') }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template #content>
              <v-card-text>
                <v-text-field
                    density="default"
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    v-model="message.message"
                    hide-details
                    flat
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('message') }}</span>
                  </template>
                </v-text-field>
              </v-card-text>
          </template>
          <template #footer>
            <v-card-text>
              <v-row>
                <v-col>
                  <base-action-button :width="'100%'" @action="closeModal('edit_meeting')">
                    <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("cancel") }}
                  </base-action-button>
                </v-col>
                <v-col>
                  <base-action-button :background="true" :width="'100%'" @action="save">
                    <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("save") }}
                  </base-action-button>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </base-modal>
      </v-card>
    </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseActionButton from "../../components/commonComponents/BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  components: {BaseActionButton, BaseModal, BaseDraggableModal, PhFloppyDisk, PhX},
  data() {
    return {
      message: null,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load(message) {
      this.message = message;
      this.openModal('edit_meeting');
    },
    async save() {
      this.$emit('edited', this.message);
      this.closeModal('edit_meeting');
    },
  }
};
</script>